import { initEnquiryForm, EnquiryConfig } from "./enquiry-form";
import { initSingleEnquiryFormPopupStates } from "./single-helpers";

declare const jQuery: any;
const $ = jQuery;

export function initPostSingle(): void
{
    if (!$(document.body).hasClass("single-post"))
    {
        return;
    }
    initPostSingleSupplierEnquiryPopup();
    initSingleEnquiryFormPopupStates();
}

function initPostSingleSupplierEnquiryPopup(): void
{
    const $button = $(`[data-supplier-enquiry-popup-btn]`);
    if ($button.length === 0)
    {
        return;
    }
    const postId: number = parseInt($button.attr("data-supplier-enquiry-popup-btn"), 10);
    const config: EnquiryConfig = {
        postType: "supplier",
        postId: postId
    };
    const $enquiryPopup = $(`[data-popup="enquiry"]`);
    const $formWrap = $enquiryPopup.find(`.hs-enquiry-form`);
    if ($enquiryPopup.length === 0)
    {
        console.error(`Missing [data-popup="enquiry"]`);
        return;
    }
    $button.on("click", function (event) {
        initEnquiryForm($formWrap, config);
        $enquiryPopup.trigger("open");
        return false;
    });
}
